import React, { Component } from 'react';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
        
    };
  }

  componentDidMount() {

  }

  render() {
    let content = null;

    return (
      <div>
        {content}
      </div>
    );
  }
}

export default Home;
